    /**
     * Split words helper function
     */
    function splitWords(el) {
        const words = el.innerText.trim().split(/\s+/); // split by spaces
        el.innerHTML = words
          .map(word => `<span class="word">${word}</span>`)
          .join(" ");
        return el.querySelectorAll(".word");
    }
